<!-- 下发计费规则接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
				"parkCode": "2KNTYVWC",
				"syncChargeServer":"",
				"chargeGroupList": [
					{
						"carTypeList": [
							{
								"carType": 2,
								"workDayList": [
									{
										"ruleCode": "3",
										"workDay": 0
									}
								]
							},
							{
								"carType": 3,
								"workDayList": [
									{
										"ruleCode": "3",
										"workDay": 0
									}
								]
							},
							{
								"carType": 4,
								"workDayList": [
									{
										"ruleCode": "3",
										"workDay": 0
									}
								]
							},
							{
								"carType": 1,
								"workDayList": [
									{
										"ruleCode": "1",
										"workDay": 0
									}
								]
							}
						],
						"groupCode": "mrsfgz",
						"groupName": "默认收费规则",
						"groupType": 1,
						"isCarType": 0
					},
					{
						"carTypeList": [
							{
								"carType": 1,
								"workDayList": [
									{
										"ruleCode": "5",
										"workDay": 0
									}
								]
							},
							{
								"carType": 2,
								"workDayList": [
									{
										"ruleCode": "5",
										"workDay": 0
									}
								]
							},
							{
								"carType": 3,
								"workDayList": [
									{
										"ruleCode": "5",
										"workDay": 0
									}
								]
							},
							{
								"carType": 4,
								"workDayList": [
									{
										"ruleCode": "5",
										"workDay": 0
									}
								]
							}
						],
						"groupCode": "1xs1y",
						"groupName": "1小时1元",
						"groupType": 1,
						"isCarType": 0
					}
				],
				"chargeRuleList": [
					{
						"customMaxCharge": 0,
						"customMaxSettleType": 2,
						"freeTime": 0,
						"freeTimeCharge": 1,
						"hour24FreeTime": 0,
						"hour24MaxCharge": 50,
						"hour24MinCharge": 0,
						"hour24SettleType": 1,
						"hour24StartTime": "00:00:00",
						"hour24Type": 0,
						"remark": "",
						"ruleDetailList": [
							{
								"chargeType": 2,
								"chargeUnit": 3,
								"chargeValue": 3,
								"endTime": "23:59:59",
								"maxCharge": 0,
								"settleType": 0,
								"sort": 25,
								"startTime": "00:00:00",
								"stepType": 2
							},
							{
								"chargeType": 2,
								"chargeUnit": 10,
								"chargeValue": 1,
								"endTime": "23:59:59",
								"maxCharge": 0,
								"settleType": 0,
								"sort": 26,
								"startTime": "00:00:00",
								"stepType": 1
							}
						],
						"ruleCode": "5",
						"ruleName": "默认收费规则"
					},
					{
						"customMaxCharge": 0,
						"customMaxSettleType": 0,
						"freeTime": 0,
						"freeTimeCharge": 1,
						"hour24FreeTime": 0,
						"hour24MaxCharge": 0.01,
						"hour24MinCharge": 0,
						"hour24SettleType": 0,
						"hour24StartTime": "00:00:00",
						"hour24Type": 0,
						"remark": "",
						"ruleDetailList": [
							{
								"chargeType": 1,
								"chargeUnit": 1440,
								"chargeValue": 0.01,
								"endTime": "23:59:59",
								"maxCharge": 0,
								"settleType": 0,
								"sort": 27,
								"startTime": "00:00:00"
							}
						],
						"ruleCode": "1",
						"ruleName": "计次0.01元"
					},
					{
						"customMaxCharge": 0,
						"customMaxSettleType": 0,
						"freeTime": 1,
						"freeTimeCharge": 1,
						"hour24FreeTime": 0,
						"hour24MaxCharge": 0,
						"hour24MinCharge": 0,
						"hour24SettleType": 0,
						"hour24StartTime": "00:00:00",
						"hour24Type": 0,
						"remark": "",
						"ruleDetailList": [
							{
								"chargeType": 1,
								"chargeUnit": 60,
								"chargeValue": 0.1,
								"endTime": "23:59:59",
								"maxCharge": 10,
								"settleType": 0,
								"sort": 13,
								"startTime": "00:00:00"
							}
						],
						"ruleCode": "3",
						"ruleName": "1小时1元"
					}
				]
			},
            responseCode: {
                "status": 1,
                "resultCode": 0,
                "message": "业务成功",
                "data": {
                }
            },
            infoData: {
                explain: "第三方接入系统通过智慧停车开放平台接口下发停车场计费规则",
                t_url: this.commonUrls.test+"setChargeRule",
                p_url: this.commonUrls.prod+"setChargeRule",
				precondition: "VEMS 2.11.1.4及以上版本",
				fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'chargeRuleList', info2: '是', info3: 'JSONArray', info4: '计费规则列表' },
						{ info1: 'chargeGroupList', info2: '是', info3: 'JSONArray', info4: '计费组列表，计费组是真正完整的计费规则' },
						{ info1: 'syncChargeServer', info2: '否', info3: 'Integer', info4: '是否马上同步计费服务,0:不马上同步,1马上同步;不填写,默认为0(注意:  前置条件 VEMS 2.16及以上版本,此参数会变更计费规则，请谨慎操作)' }
                        ]
                },{
                    titleName: 'chargeRuleList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'ruleName', info2: '是', info3: 'String', info4: '计费规则名称' },
                        { info1: 'ruleCode', info2: '是', info3: 'String', info4: '计费规则编号，用于计费组和计费规则之间关系绑定，由用户自己设定，保证唯一' },
                        { info1: 'freeTime', info2: '是', info3: 'Integer', info4: '免费时长，单位分钟' },
                        { info1: 'freeTimeCharge', info2: '是', info3: 'Decimal', info4: '停车时长超过免费时长后，免费时长是否计费，0不计费，1计费' },
                        { info1: 'hour24MinCharge', info2: '是', info3: 'Decimal', info4: '24小时最小计费' },
                        { info1: 'hour24MaxCharge', info2: '是', info3: 'Decimal', info4: '24小时最大计费' },
                        { info1: 'hour24SettleType', info2: '是', info3: 'Integer', info4: '24小时结算类型，0自然日结算，1强制结算（默认），2封顶结算，没有特殊要求，传1强制结算即可' },
                        { info1: 'hour24Type', info2: '是', info3: 'Integer', info4: '24小时类型，0停车时长，1自然日，默认0停车时长' },
                        { info1: 'hour24StartTime', info2: '否', info3: 'String', info4: '24小时起始时间，自然日时指定这个值有效，HH:mm' },
                        { info1: 'hour24FreeTime', info2: '是', info3: 'Integer', info4: '是否每个24小时都有免费时长，0无，1有。默认0无' },
                        { info1: 'customMaxTime', info2: '否', info3: 'Integer', info4: '自定义封顶时长，24小时内时长，单位分钟' },
                        { info1: 'customMaxCharge', info2: '否', info3: 'Decimal', info4: '自定义封顶金额' },
                        { info1: 'customMaxSettleType', info2: '否', info3: 'Integer', info4: '自定义封顶结算类型，0自然日结算，1强制结算（默认），2封顶结算' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                        { info1: 'ruleDetailList', info2: '是', info3: 'JSONArray', info4: '详细计费规则列表' }
                        ]
                },{
                    titleName: 'ruleDetailList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '起始时间，HH:mm:ss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间，HH:mm:ss' },
                        { info1: 'chargeType', info2: '是', info3: 'Integer', info4: '收费方式，1单价，2定额，3计次' },
                        { info1: 'stepType', info2: '否', info3: 'Integer', info4: '步长类型，chargeType为2定额时必须，1表示固定额(总时间，总额) 2表示循环（循环以step_unit的计费时间收取value的金额，需要加上之前的总金额' },
                        { info1: 'chargeUnit', info2: '是', info3: 'Integer', info4: '收费单位，单位分钟' },
                        { info1: 'chargeValue', info2: '是', info3: 'Decimal', info4: '收费单价，单位元' },
                        { info1: 'settleType', info2: '是', info3: 'Integer', info4: '结算类型，0自然日结算，1强制结算（默认），2封顶结算，没有特殊要求，传1强制结算即可' },
                        { info1: 'maxCharge', info2: '否', info3: 'Decimal', info4: '最高收费，单位元' },
                        { info1: 'sort', info2: '是', info3: 'Integer', info4: '计费规则明细序号，从1开始' }
                        ]
                },{
                    titleName: 'chargeGroupList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'groupName', info2: '是', info3: 'String', info4: '计费组名称' },
                        { info1: 'groupCode', info2: '是', info3: 'String', info4: '第三方平台指定的计费组唯一编号' },
                        { info1: 'groupType', info2: '是', info3: 'Integer', info4: '0默认计费规则，1非默认计费规则' },
                        { info1: 'isCarType', info2: '是', info3: 'Integer', info4: '是否区分大小车，0不区分大小车，1区分大' },
                        { info1: 'carTypeList', info2: '是', info3: 'JSONArray', info4: '车辆类型列表' }
                        ]
                },{
                    titleName: 'carTypeList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carType', info2: '是', info3: 'Integer', info4: '大小车类型，0不区分，1小车，2大车，3超大车，4中型车' },
                        { info1: 'workDayList', info2: '是', info3: 'JSONArray', info4: '工作日/非工作日列表' }
                        ]
                },{
                    titleName: 'workDayList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'workDay', info2: '是', info3: 'Integer', info4: '工作日类型，0不区分，1工作日，2非工作日' },
                        { info1: 'ruleCode', info2: '是', info3: 'String', info4: '关联的计费规则编号，对应chargeRule里面的ruleCode' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/trade/setChargeRule.vue